import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Hourglass = ({
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE,
  className = '~w-4/5 ~h-4/5'
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M6.66602 5H33.3327'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.16602 5V8.38398C9.16602 10.4538 10.1274 12.4062 11.7679 13.6681L19.9993 20L28.2307 13.6681C29.8713 12.4062 30.8327 10.4538 30.8327 8.38398V5'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.16602 35V31.616C9.16602 29.5462 10.1274 27.5938 11.7679 26.3318L19.9993 20L28.2307 26.3318C29.8713 27.5938 30.8327 29.5462 30.8327 31.616V35'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66602 35H33.3327'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Hourglass;
